import Add16 from '@carbon/icons-react/es/add/16';
import React, { FC } from 'react';
import { Button } from 'components/atoms/button';
import { Categories as CategoriesT } from '../categories';
import { AddCategory as Wrapper, Input } from './components';
import { useAdd } from './use-add';

interface Props {
  categories: CategoriesT;
  onAdd: (name: string) => void;
}

export const AddCategory: FC<Props> = ({ categories, onAdd }) => {
  const { placeholder, text, setText, handleAdd, loading, addCaption } = useAdd(
    categories,
    onAdd,
  );

  return (
    <Wrapper>
      <Input
        placeholder={placeholder}
        value={text}
        onChange={(ev) => setText(ev.target.value ?? '')}
        onPressEnter={handleAdd}
      />
      <Button
        icon={<Add16 />}
        iconPlacement="right"
        type="primary"
        disabled={loading || text.length === 0}
        onClick={handleAdd}
      >
        {addCaption}
      </Button>
    </Wrapper>
  );
};
